import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '2rem',
  },
}))

export default styles
